import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { createRelatedLocationFormSchema } from './create-related-location-form.schema';
import { useEffect } from 'react';

export const useCreateRelatedLocationForm = ({ displayInfo }) => {
  const form = useForm({
    resolver: yupResolver(createRelatedLocationFormSchema, {}),
    defaultValues: {
      displayInfo,
    },
  });

  const { reset } = form;
  useEffect(() => {
    reset({ displayInfo });
  }, [displayInfo, reset]);

  return { form };
};
